import setupTooltips from '../shared/enquiry-tooltips';
import paymentModal from '../shared/payment-modal';
import csvImport from '../shared/csv-import';
import operatorInternalNotes from '../shared/operator-internal-notes';

export default {
  loaded() {
    setupTooltips()
    paymentModal()
    csvImport()
    operatorInternalNotes()
  }
};
